
import advancePaymentSetupImage from "~/assets/images/advance-payment-setup.svg";

export default {
  props: {
    showTransferConfirmationDialog: Boolean
  },
  data() {
    return {
      advancePaymentSetupImage
    };
  }
};
